exports = module.exports = require("../../../../../../../../questioneditor/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ck .ck-fake-panel{position:absolute;z-index:calc(var(--ck-z-modal) - 1)}.ck .ck-fake-panel div{position:absolute}.ck .ck-fake-panel div:first-child{z-index:2}.ck .ck-fake-panel div:nth-child(2){z-index:1}", ""]);

// exports
